import React from 'react';
import { Box, Typography, Container, Grid, IconButton, Divider, Link as MuiLink } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TelegramIcon from '@mui/icons-material/Telegram';
// import InstagramIcon from '@mui/icons-material/Instagram';
// import EmailIcon from '@mui/icons-material/Email';

const socialLinks = [
  { icon: <LinkedInIcon />, url: 'https://www.linkedin.com/company/syrdevuae/', label: 'LinkedIn' },
  { icon: <YouTubeIcon />, url: 'https://youtube.com/@uaesyrdev?si=RutdOZ5Qpkq5jseV', label: 'YouTube' },
  { icon: <TelegramIcon />, url: 'https://t.me/uaeSyrDev', label: 'Telegram' },
  { icon: <FacebookIcon />, url: 'https://www.facebook.com/groups/6530855480347056/?ref=share&mibextid=NSMWBT', label: 'Facebook' },
  // { icon: <InstagramIcon />, url: 'https://instagram.com/syrdevuae', label: 'Instagram' },
  // { icon: <EmailIcon />, url: 'mailto:info@syrdevuae.com', label: 'Email' },
];

const FooterSection: React.FC = () => (
  <Box sx={{ bgcolor: 'secondary.light', color: 'white', py: 5 }}>
    <Container maxWidth="lg">
      <Grid container spacing={4} alignItems="center">
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Contact Information
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Email: <MuiLink href="mailto:info@syrdevuae.com" color="inherit" underline="always">info@syrdevuae.com</MuiLink>
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
          Phone: <MuiLink href="tel:+971525585292" color="inherit" underline="always">+971 52 558 5292</MuiLink>
          </Typography>
          <Typography variant="body1">
            Dubai, United Arab Emirates
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Connect with us
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            {socialLinks.map((social) => (
              <IconButton
                key={social.label}
                component="a"
                href={social.url}
                target="_blank"
                rel="noopener"
                color="inherit"
                sx={{ bgcolor: 'primary.main', '&:hover': { bgcolor: 'secondary.main' } }}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>
        </Grid>
      </Grid>
      <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.2)' }} />
      <Typography variant="body2" color="rgba(255,255,255,0.7)" align="center">
        &copy; {new Date().getFullYear()} SyrDevUae. All rights reserved.
      </Typography>
      <Typography variant="body2" color="rgba(255,255,255,0.7)" align="center" sx={{ mt: 1 }}>
        Powered by <MuiLink href="https://nabilalsaadi.com" color="inherit" target="_blank" rel="noopener">nabilalsaadi.com</MuiLink>
      </Typography>
    </Container>
  </Box>
);

export default FooterSection; 